module.exports = __webpack_public_path__ + "img/tt.e3e1929d.svg";